import React, { useEffect, useState } from "react";
import SessionTracker from "../UI/SessionTracker";
import styles from "../../_css/Home.module.css";
import { AudioLines } from "lucide-react";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { getStatisticsData } from "../../requests";
import { deleteAuthToken, notifyError } from "../../utils/helper";
import { HOME_DATA_RIGHT_BAR } from "../../data/staticDataHome";
import { useSelector } from "react-redux";
import { translateText } from "../helper/formatters";

function RightBar({ setRemainingDays }) {
  const dispatch = useDispatch();
  const [statisticsData, setStatisticsData] = useState({
    totalSessions: 0,
    usedSessions: 0,
    mostUsedSessionName: "",
    mostUsedSessionNameArabic: "",
  });

  const lang = useSelector((state) => state.language.lang);
  const {
    personalStats,
    totalSessions,
    thisMonth,
    mostUsedSession,
    sessionTranslation,
  } = HOME_DATA_RIGHT_BAR[lang];

  useEffect(() => {
    handleGetStatistics();
  }, []);

  const handleGetStatistics = async () => {
    dispatch(startLoader());
    try {
      const response = await getStatisticsData();
      if (response.status === 200) {
        const { max_hits, hits_remaining, sub_end } = response.data.statistics;
        let mostUsedSessionName = response.data.mostUsedSessionName;
        let mostUsedSessionNameArabic = response.data.mostUsedSessionNameArabic;

     


        // calculate used sessions by subtracting hits_remaining from max_hits
        const usedSessions = max_hits - hits_remaining;

        setStatisticsData({
          totalSessions: max_hits || 0,
          usedSessions: usedSessions || 0,
          mostUsedSessionName: mostUsedSessionName || "N/A",
          mostUsedSessionNameArabic: mostUsedSessionNameArabic || "N/A",
        });
        setRemainingDays(
          Math.ceil(
            (new Date(sub_end).getTime() - new Date().getTime()) /
              (1000 * 60 * 60 * 24)
          )
        );
      }
      // Set pagination data from API response
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      notifyError(error?.response?.data?.message);
      console.error("Error in sending message:", error);
    }
    dispatch(stopLoader());
  };

  return (
    <div className={styles.rightBar}>
      <SessionTracker
        totalSessions={statisticsData.totalSessions}
        usedSessions={statisticsData.usedSessions}
      />

      <hr />
      <div>
        <h3 className={styles.title}>{personalStats}</h3>
        <div className={styles.personalStatistics}>
          <div>
            <p>{totalSessions}</p>
            <h4>
              {statisticsData.totalSessions || 0} 
              {/* {sessionTranslation} */}
            </h4>
            <p>{thisMonth}</p>
          </div>
          <span>
            <i>
              <AudioLines height={14} width={16} fill="white" color="white" />
            </i>
          </span>
        </div>
        <div className={styles.personalStatistics2}>
          <div>
            <p>{mostUsedSession}</p>
            <h4>{lang == "ar" ? statisticsData.mostUsedSessionNameArabic : statisticsData.mostUsedSessionName || "N/A"}</h4>
            <p>{thisMonth}</p>
          </div>
          <span>
            <i>
              <AudioLines height={14} width={16} fill="white" color="white" />
            </i>
          </span>
        </div>
      </div>
    </div>
  );
}

export default RightBar;
